
import React from 'react'
import DocumentMeta from 'react-document-meta'
import ShowHide from 'ui/ShowHide'
import Loader from 'ui/Loader'
import LoggedOutHeader from './LoggedOutHeader'
import LoginEnableAlert from './LoginEnableAlert'
import LoginError from './LoginError'
import LoginForm from './LoginForm'
import LoginFooter from './LoginFooter'
import css from './Login.module.css'

const Login = props => (
  <div className={css.main}>
    <DocumentMeta title='Login - Segment' />

    <LoggedOutHeader title='Login to Segment' />

    <ShowHide show={window.segment.enable}>
      <LoginEnableAlert enable={window.segment.enable} />
    </ShowHide>

    <ShowHide show={props.didSubmitWrongPassword}>
      <LoginError wrongPassword />
    </ShowHide>

    <ShowHide show={props.didSubmitWrongEmail}>
      <LoginError wrongEmail />
    </ShowHide>

    <ShowHide show={props.hasError}>
      <LoginError unknownError />
    </ShowHide>

    <ShowHide show={!props.didCreate}>
      <LoginForm
        onSubmit={props.onSubmit}
        isLoading={props.isLoading}
        email={props.email}
        password={props.password} />
    </ShowHide>
    <ShowHide show={props.didCreate}>
      {/* loader rather to show the user _something_ is happening */}
      <Loader isLoading padding='400' />
    </ShowHide>

    <LoginFooter />
  </div>
)

export default Login



// WEBPACK FOOTER //
// ./components/Login.js